import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  message?: string;
};

export class AppRouteHealthGuard extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: any): State {
    return {
      hasError: true,
      message: error?.message || 'Erreur inconnue',
    };
  }

  componentDidCatch(error: any, info: any) {
    console.error('Forfeo route error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6">
          <div className="max-w-xl w-full rounded-[2rem] border border-white/10 bg-white/10 p-8 shadow-2xl">
            <p className="text-xs uppercase tracking-[0.25em] text-cyan-300 font-black mb-3">
              Forfeo
            </p>
            <h1 className="text-3xl font-black mb-3">Une section doit être rechargée</h1>
            <p className="text-slate-200 mb-6">
              La page a rencontré une erreur temporaire. Recharge la page ou retourne à l’accueil.
            </p>
            {this.state.message && (
              <pre className="mb-6 max-h-32 overflow-auto rounded-xl bg-black/30 p-3 text-xs text-slate-300">
                {this.state.message}
              </pre>
            )}
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => window.location.reload()}
                className="rounded-full bg-white px-5 py-3 text-sm font-black text-slate-950"
              >
                Recharger
              </button>
              <a
                href="/"
                className="rounded-full border border-white/20 px-5 py-3 text-sm font-black text-white"
              >
                Retour accueil
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
